import { useState, useEffect } from "react";
import * as msTeams from "@microsoft/teams-js";

export interface IMsTeamsContext {
    isInitializing: boolean;
    isAppInsideMsTeams: boolean;
    currentMsTeamsThemeName: string;
    teamsClientType: msTeams.HostClientType;
    tenantId: string | undefined;
}

const useMsTeamsContext = (): IMsTeamsContext => {
    const [isInitializing, setIsInitializing] = useState(true);
    const [isAppInsideMsTeams, setIsAppInsideMsTeams] = useState(false);
    const [currentMsTeamsThemeName, setCurrentMsTeamsThemeName] = useState("default");
    const [teamsClientType, setTeamsClientType] = useState<msTeams.HostClientType>(msTeams.HostClientType.desktop);
    const [tenantId, setTenantId] = useState<string | undefined>();

    useEffect(() => {
        const init = async () => {
            try {
                await msTeams.app.initialize();
                const teamsContext = await msTeams.app.getContext();
                setIsAppInsideMsTeams(true);
                setCurrentMsTeamsThemeName(teamsContext.app.theme);
                setTeamsClientType(teamsContext.app.host.clientType);
                setTenantId(teamsContext.user?.tenant?.id.toLowerCase());
                msTeams.app.registerOnThemeChangeHandler((themeName) => {
                    setCurrentMsTeamsThemeName(themeName);
                });
                msTeams.app.notifySuccess();
            } catch {
                // Not running inside Teams
            } finally {
                setIsInitializing(false);
            }
        };
        init();
    }, []);

    return {
        isInitializing,
        isAppInsideMsTeams,
        currentMsTeamsThemeName,
        teamsClientType,
        tenantId,
    };
};

export default useMsTeamsContext;
